// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      height: 8px;
      width: 8px;
      display: inline-block;
      line-height: 0;
    }

    svg {
      fill: #00900E;
    }

    .danger-color {
      fill: #D44C4C;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/core/svg-icons/circle-icon.component.ts"],"names":[],"mappings":";IACI;MACE,WAAW;MACX,UAAU;MACV,qBAAqB;MACrB,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf","sourcesContent":["\n    :host {\n      height: 8px;\n      width: 8px;\n      display: inline-block;\n      line-height: 0;\n    }\n\n    svg {\n      fill: #00900E;\n    }\n\n    .danger-color {\n      fill: #D44C4C;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
